export default function EducationSectionHeading({text}) {
    return (
        <h2 className="text-xl font-medium pb-6 mb-6 border-b-4 border-education uppercase inline-block">{text}</h2>
    )
}